import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Unstable_Grid2 as Grid,
} from '@mui/material';
import { Form as FormikForm, Formik } from 'formik';

import { UpdateUserManagementUserProfileInput, UserProfileSearchFragment } from 'api';
import { Loaders } from 'components';

import { DepartmentDropdown, LocationDropdown, RoleDropdown } from './Edit';

interface Props {
  open: boolean;
  onCancel: () => void;
  onConfirm: (input: UpdateUserManagementUserProfileInput) => void;
  userProfile: UserProfileSearchFragment;
}

const EditDialog: FC<Props> = ({ open, onCancel, onConfirm, userProfile }) => {
  const { t } = useTranslation();

  const initialValues: UpdateUserManagementUserProfileInput = {
    id: userProfile.id,
    location_id: userProfile.location_id,
    department_id: userProfile.department_id,
    user_type: userProfile.user_type,
  };

  function onSubmit(values: UpdateUserManagementUserProfileInput) {
    onConfirm(values);
  }

  function renderButtons(isLoading: boolean) {
    return (
      <Grid container justifyContent="flex-end" alignItems="center">
        <Grid marginRight={2}>
          <Button fullWidth color="secondary" variant="contained" size="large" onClick={onCancel}>
            {t('common:cancel')}
          </Button>
        </Grid>
        <Grid>
          <Button type="submit" fullWidth color="primary" variant="contained" size="large">
            {isLoading ? <Loaders.Button size={24} /> : t('common:apply')}
          </Button>
        </Grid>
      </Grid>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      sx={{
        minWidth: 600,
      }}
    >
      <Formik onSubmit={onSubmit} initialValues={initialValues}>
        {({ isSubmitting }) => (
          <FormikForm>
            <DialogTitle sx={{ border: 'none', marginBottom: 4 }}>
              {t('admin:editUserAttributes')}
            </DialogTitle>

            <DialogContent sx={{ padding: 2 }}>
              <Grid container direction="column">
                <DepartmentDropdown />

                <LocationDropdown />

                <RoleDropdown />
              </Grid>
            </DialogContent>

            <Grid xs={12}>
              <Divider />
            </Grid>

            <DialogActions>{renderButtons(isSubmitting)}</DialogActions>
          </FormikForm>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditDialog;
